/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atu12345678Inputs */

const en_atu12345678 = /** @type {(inputs: Atu12345678Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATU12345678`)
};

const de_atu12345678 = /** @type {(inputs: Atu12345678Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATU12345678`)
};

/**
* | output |
* | --- |
* | "ATU12345678" |
*
* @param {Atu12345678Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const atu12345678 = /** @type {((inputs?: Atu12345678Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atu12345678Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_atu12345678(inputs)
	return de_atu12345678(inputs)
});